import styled from 'styled-components';
import { LinkButton } from 'components/Toolkit/Button/LinkButton';

const UserProfileIconContainer = styled.button`
  padding: 0;
  width: 48px;
  height: 48px;
  cursor: pointer;
  pointer-events: auto;
`;

const TitleButton = styled(LinkButton)`
  max-width: 100%;
`;

export { UserProfileIconContainer, TitleButton };
